<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wvqa7J/tc-custom/9781455611560.jpg?1728155802959" alt="This image is the cover for the book Saints, The Superdome, and the Scandal"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Saints, The Superdome, and the Scandal
      </h1>
      <p class="bookDescription body article font2">
        <p>"Filled with insider stories about the sports scene of New Orleans and previously untold secret political maneuvers made to bring the Saints to New Orleans." -New Orleans Times-Picayune</p><p>"Dave Dixon offers a behind-the-scenes look at the New Orleans NFL." -(LA) The Daily Advertiser</p><p>Before the Saints were synonymous with New Orleans, Dave Dixon was gathering support to create a team and build a Superdome to accommodate them. The man affectionately known as the "Father of the Saints" gives an insider's perspective on the historical events that shaped the New Orleans sports scene.</p><p>Little-known facts reveal the negotiations, the payoffs, and the votes that eventually led to the announcement of the sixteenth franchise of the National Football League on November 1, 1966. Nine years after the NFL announcement, the Louisiana Superdome opened on August 3, 1975, as a fifty-two-acre, 269,000-square-foot facility that forever changed the skyline of New Orleans. The opening of this facility not only served as the home of the Saints, but later became home to evacuees of Hurricane Katrina.</p><p>As Dixon reflects on the efforts of the key individuals who worked collectively to make this happen, he shares insight on a national scandal that he credits with altering our political landscape following the 1968 presidential elections and eventually leading to the fall of John McKeithen, a dear friend and supporter of the Saints.</p><p>ABOUT THE AUTHOR Dave Dixon, named one of the "Ten Most Important New Orleanians of the 20th Century" by New Orleans Magazine was widely known for his time as the executive director of the Louisiana Superdome. He was the founder of the United States Football League (USFL) in 1983 and cofounder of World Championship Tennis. He served as a member of Loyola University's Board of Trustees and spoke to both Harvard University and Stanford University graduate schools of business. Dixon passed away in August of 2010.</p><p></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dave Dixon
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pelican Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?663a8403